import React, { useState, useEffect } from 'react';
import PageUnderDevelopment from 'components/PageUnderDevelopment/PageUnderDevelopment';
// import Button from "@material-ui/core/Button";
// import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MenuItem from "@material-ui/core/MenuItem";
import {
    Typography,
    Paper,
    TextField,
    Grid,
    Button,
    Box,
    CssBaseline,
} from "@material-ui/core";
import Newsignaturelogo from 'assets/img/Henry Schein programs.png';
import Header2 from 'assets/img/HeaderNew2.png';
import SignatureLogo from 'assets/img/Signature Logo.png';
import ThriveSignaturegep from 'assets/img/Thrive Signaturegep.png';
import ThriveservicePlus from 'assets/img/Thrive Service Plus.png';
import ServicePlusLogo from 'assets/img/Service Plus Logo.png';
import { useHistory } from 'react-router-dom';
import upgardeloyalty from 'apis/UpgradeLoyalty/upgardeloyalty';
import { toast } from "react-toastify";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { withStyles } from '@material-ui/styles';
import { Tooltip } from '@material-ui/core/index';


/**
 * A reusable component with example props and state.
 */
const ThriveServiceplus = () => {
    const [popupOpen, setPopupOpen] = useState(true);
    const { getShiptoDetail } = upgardeloyalty();
    const [shipto, setShipto] = useState('');
    const [country, setCountry] = useState('US');
    const history = useHistory();
    const [data, setdata] = useState("")
    const [planType, setPlanType] = useState({
        signature: false,
        servicePlus: false,
        signaturestatus: null,
        serviceplusstatus: null
    })

    let GreenTooltip

    GreenTooltip = withStyles({
        tooltip: {
            color: "black",
            backgroundColor: "#e8eaeb",
            width: "500px",
            fontSize: "12px",
            marginRight: "50px"
        },
        arrow: {
            "&:before": {
                backgroundColor: "#e8eaeb",
            },
        },
    })(Tooltip);



    localStorage.setItem('countryname', country);
    localStorage.setItem('shipto', shipto);

    const handleSkip = async () => {
        setPopupOpen(false)

    }




    const handleSearch = async () => {
        if (!shipto) {
            return toast.error("Please enter the account number")
        }


        try {

            let values = {
                shipto: shipto,
                country: country
            };
            let res = await getShiptoDetail(values);


            if (res.result_status == 0) {
                return toast.error(res.message);
            }
            if (res.result_status == 1) {
                setdata(res.data)
                setPlanType({
                    signature: res?.data?.signature_flag,
                    servicePlus: res?.data?.service_plus_flag,
                    signaturestatus: res?.data?.signature_status,
                    serviceplusstatus: res?.data?.service_plus_status
                });
                setPopupOpen(false);
            }
            return;
        }
        catch (err) {
            console.log({ err });
        }
    };

    return (
        <>
            {process.env.REACT_APP_ENABLE_UPGRADE_LOYALTY != "false" ?
                <><div style={{ width: '90%', margin: 'auto', background: '#fff', minHeight: '100vh' }}>
                    <Box style={{ padding: "60px" }}>
                        <img style={{ width: "100%" }} src={Newsignaturelogo}></img>
                        <div style={{display:"flex",justifyContent:"center"}}>
                        <img style={{ marginTop: "10px" }} src={Header2}></img>
                        </div>
                        <Typography variant="h4" align="center" color="primary" gutterBottom>
                            {/* Henry Schein Thrive */}
                        </Typography>
                        {/* <Typography variant="h6" align="center" gutterBottom>
      Empower Your Practice’s Success with Henry Schein Thrive
    </Typography> */}

                        {/* Cards Grid */}
                        <Grid container spacing={4} alignItems="stretch" style={{width:"1980px",marginLeft:"60px" ,marginTop:"20px"}}>

                           {/* Service Plus Card */}
                            <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                                <Paper
                                    elevation={3}
                                    style={{
                                        height:"1000px"
                                        // flex: 1,
                                        // display: 'flex',
                                        // flexDirection: 'column',
                                        // alignItems: 'center',
                                        // justifyContent: 'space-between',
                                        // p: 44,
                                        // textAlign: 'center'
                                    }}
                                >
                                    <div style={{
                                        display: 'flex',

                                        justifyContent: 'center', fontSize: "30px"
                                    }}>
                                        <div style={{ fontSize: "30px" }}>
                                            <img style={{ width: "200px", textAlign: "center", marginTop: "20px" }} src={ThriveservicePlus}></img>

                                        </div>
                                        {/* <div>
                                        <img src={ServicePlusLogo} style={{ width: "100px", marginRight: "130px", marginTop: "20px" }}></img>
                                    </div> */}
                                    </div>
                                    <div>
                                        {/* <div style={{ textAlign: "center" }}>
                                        <Typography variant="h6" sx={{ color: 'black', fontWeight: 'bold', mb: 2 }}>
                                            Henry Schein Thrive Service Plus
                                        </Typography>
                                    </div> */}
                                        <div style={{ marginLeft: "30px", marginTop: "20px" }} >
                                            <Typography variant="body2" paragraph>
                                                A comprehensive repair coverage subscription for your large equipment, powered by Henry Schein ServiceFirst technicians. An exclusive subscription only available to Henry Schein Thrive Rewards members!
                                            </Typography>
                                            <span style={{ fontWeight: "bold" }}>With Thrive Service Plus You'll Receive:</span>
                                            <ul style={{ padding: 0, margin: '1rem 0', fontWeight: 'bold', marginLeft: "30px" }}>
                                                <li>Labor Included On Large Equipment<br /><small style={{ fontWeight: 'normal' }}> Labor only Monday–Friday 7am–9pm EST</small></li>
                                                <li>Includes Calls To The Technical Advisor Line</li>
                                                <li>Emergency Response Service<br /> <small style={{ fontWeight: 'normal' }}>During Normal Business Hours</small></li>
                                            </ul>
                                        </div>
                                        <div style={{ marginLeft: "35px" }}>Membership Cost:<br />
                                            Tier 1: $299/Month (1-6 Operatories)<br />
                                            Tier 2: $499/Month (7-12 Operatories)<br />
                                            Tier 3: $599/Month (13-20 Operatories)</div>
                                    </div>
                                    <div style={{ marginLeft: "35px", marginTop: "243px" }}><small>*Subscription enrollment only available to Private Practice customers enrolled in Thrive Rewards. Preventative maintenance and pre-scheduled calls are not included. Labor only, parts not included. For ordinary wear and tear that results from normal use of the equipment in accordance with manufacturer's instructions. Please refer to the <a target="_blank" rel="noopener noreferrer" href="https://acrobat.adobe.com/id/urn:aaid:sc:VA6C2:d2e7d5a5-2cde-485d-ad54-234d64b79634?viewer%21megaVerb=group-discover">Henry Schein Thrive Service Plus Service Agreement</a> for full Thrive Service Plus benefit details.</small></div>
                                    <div style={{ textAlign: "center", marginTop: "11px", marginBottom: "10px" }}>
                                        {/* Not enrolled at all */}
                                        {!planType?.servicePlus ? (
                                            <Button
                                                style={{ textAlign: "center", marginBottom: "8px", marginTop: "39px" }}
                                                variant="contained"
                                                color="primary"
                                                onClick={() => history.push('thrive-service-plus-enroll', { data: data })}
                                            >
                                                Enroll
                                            </Button>
                                        ) : planType?.serviceplusstatus === 'Inprogress' && planType?.servicePlus ? (
                                            // Enrolled but status is Inprogress
                                            <div style={{ padding: '6px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                                                <div
                                                    style={{
                                                        backgroundColor: '#efd4e1',
                                                        color: '#7d004c',
                                                        padding: '2px 21px',
                                                        textAlign: 'center',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                                                        // maxWidth: '400px',
                                                        borderRadius: '8px',
                                                        marginTop: '39px'
                                                    }}

                                                >
                                                    Enrollment submitted! We’re processing your Thrive Service Plus <br />
                                                    request—we’ll notify you once it's complete.
                                                </div>
                                            </div>
                                        ) : (
                                            // Enrolled and status is null or not 'Inprogress'
                                            <div style={{ padding: '6px', display: 'flex', justifyContent: 'center' }}>
                                                <div
                                                    style={{
                                                        backgroundColor: '#efd4e1',
                                                        color: '#7d004c',
                                                        padding: '6px 24px',
                                                        textAlign: 'center',
                                                        fontSize: '14px',
                                                        fontWeight: 700,
                                                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                                                        maxWidth: '346px',
                                                        width: '100%',
                                                        marginTop: '39px'
                                                    }}
                                                >
                                                    You are already enrolled in Thrive Service Plus.
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </Paper>
                            </Grid>

                        </Grid>
                    </Box>
                </div>
                    {/* <Dialog
                        open={popupOpen === true}
                        onClose={(event, reason) => {
                            // Prevent closing on backdrop click or Escape key
                            if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
                            setPopupOpen(false);
                        }}
                        aria-describedby="alert-dialog-slide-description"
                    >
                        <DialogContent>
                            <div
                                style={{
                                    width: '100%',
                                    margin: 'auto',
                                    background: '#fff',
                                    padding: 30,
                                    boxSizing: 'border-box',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        marginBottom: 16,
                                    }}
                                >
                                   Enter your Account Number to Check eligibility to Get Started
                                </div>


                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <TextField
                                            id="billto"
                                            // placeholder="Enter shipto"
                                            label="Account #"
                                            type="text"
                                            variant="outlined"
                                            style={{ width: '100%', marginBottom: 16 }}
                                            autoComplete="off"
                                            value={shipto}
                                            onChange={(e) => setShipto(e.target.value)}
                                        />
                                        <GreenTooltip title={('Your account number can be found at the top of the HenryScheinDental.com page or on your Account Dashboard.')} placement="bottom" arrow>
                                            <InfoOutlinedIcon style={{ fontSize: 15, color: '#0a72ba', marginLeft: 3, marginTop: "17px" }} />
                                        </GreenTooltip>
                                    </div>

                                    <TextField
          select
          label="Select Country"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
          variant="outlined"
          style={{ width: '100%', marginBottom: 16 }}
        >
          <MenuItem value="US">US</MenuItem>
          <MenuItem value="CA">CA</MenuItem>
        </TextField> 

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ width: 120 }}
                                        onClick={handleSearch}
                                    >
                                        Submit
                                    </Button>

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ width: 120,marginTop:10 }}
                                        onClick={handleSkip}
                                    >
                                        Skip
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </Dialog> */}
                    
                    </>
                : <PageUnderDevelopment />}
        </>
    );
};


export default ThriveServiceplus;
